import React from "react";
import { Youtube, Facebook } from "lucide-react";

const Footer = () => {
  return (
    <footer
      className="py-16 md:py-20 bg-ivory"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col items-center text-center">
        <p
          className="font-serif italic text-2xl md:text-3xl"
          style={{ color: "var(--ink)" }}
          data-testid="footer-brand"
        >
          The Journey to Freedom
        </p>
        <p
          className="mt-4 eyebrow"
          style={{ fontSize: "0.62rem", letterSpacing: "0.4em" }}
          data-testid="footer-mantra"
        >
          Remember · Become · Be Free
        </p>

        <div
          className="mt-10 flex items-center gap-8"
          data-testid="footer-socials"
        >          <a
            href="https://www.youtube.com/channel/UC4F8JOBrjdSIIWLNpIWp0oA"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube"
            className="text-[color:var(--ink-soft)] hover:text-[color:var(--gold-deep)] transition-colors"
            data-testid="footer-youtube"
          >
            <Youtube strokeWidth={1.2} className="w-6 h-6" />
          </a>
          <a
            href="https://www.facebook.com/groups/cominghometoyourlimitlessself"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook Community"
            className="text-[color:var(--ink-soft)] hover:text-[color:var(--gold-deep)] transition-colors"
            data-testid="footer-facebook"
          >
            <Facebook strokeWidth={1.2} className="w-6 h-6" />
          </a>
        </div>

        <div
          className="mt-12"
          aria-hidden="true"
        />

        <p
          className="mt-2 text-xs tracking-wider text-[color:var(--ink-soft)]"
          data-testid="footer-copyright"
        >
          © {new Date().getFullYear()} Persephone Dennis · The Journey to
          Freedom. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
